import React from "react";
import { Link } from "react-router";
import { Card, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { Palette, Scale } from "lucide-react";

const ToolsPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold my-4">Tools</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Link to="/tools/colour-wheel">
          <Card className="hover:bg-accent transition-colors cursor-pointer">
            <CardHeader>
              <Palette className="h-8 w-8 mb-2 text-muted-foreground" />
              <CardTitle>Colour Wheel</CardTitle>
              <CardDescription>
                Explore complementary, split, triadic and tetradic colour
                schemes for Bullseye glass.
              </CardDescription>
            </CardHeader>
          </Card>
        </Link>
        <Link to="/tools/weight-calculator">
          <Card className="hover:bg-accent transition-colors cursor-pointer">
            <CardHeader>
              <Scale className="h-8 w-8 mb-2 text-muted-foreground" />
              <CardTitle>Glass Weight Calculator</CardTitle>
              <CardDescription>
                Calculate the weight of glass pieces by shape, dimensions and
                thickness.
              </CardDescription>
            </CardHeader>
          </Card>
        </Link>
      </div>
    </div>
  );
};

export default ToolsPage;
